import React, { useRef, useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  videoUrl: string;
}

export const VideoModal = ({ isOpen, onClose, title, videoUrl }: VideoModalProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isIframe, setIsIframe] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
      // Vimeo oder YouTube = iframe, alles andere = video
      setIsIframe(
        videoUrl.includes('vimeo.com') ||
        videoUrl.includes('youtube.com') ||
        videoUrl.includes('youtu.be')
      );
    }
  }, [isOpen, videoUrl]);

  useEffect(() => {
    // Stop video bei Modal close
    return () => {
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.removeAttribute('src');
        videoRef.current.load();
      }
    };
  }, []);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[80vw] max-h-[90vh]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>
            Click outside to close this video
          </DialogDescription>
        </DialogHeader>

        <div className="aspect-video w-full">
          {isLoading && (
            <div className="w-full h-full bg-gray-200 rounded-lg flex items-center justify-center">
              <p className="text-gray-500">Loading video...</p>
            </div>
          )}

          {isIframe ? (
            <iframe
              ref={iframeRef}
              src={videoUrl}
              className={`w-full h-full rounded-lg ${isLoading ? 'hidden' : ''}`}
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              onLoad={() => setIsLoading(false)}
              title={title}
            />
          ) : (
            <video
              ref={videoRef}
              src={videoUrl}
              className={`w-full h-full rounded-lg ${isLoading ? 'hidden' : ''}`}
              controls
              playsInline
              preload="metadata"
              onLoadedData={() => setIsLoading(false)}
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};